import { createRouter, createWebHistory } from "vue-router";
import ReservationPage from "@/views/HomeView.vue";

const routes = [
  {
    path: "/:side/undangan",
    name: "ReservationPage",
    component: ReservationPage,
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

export default router;
